module.exports = __webpack_public_path__ + "img/lyq_ys1.fdfddcc4.png";